import React from "react";
import { Logo } from "./Logo";

const sections = [
  {
    title: "Product",
    links: [
      { l: "Problem", h: "#problem" },
      { l: "Pillars", h: "#pillars" },
      { l: "How it works", h: "#usp" },
      { l: "AI Coach", h: "#coach" },
    ],
  },
  {
    title: "Beta",
    links: [
      { l: "Request Access", h: "#waitlist" },
      { l: "Lab intelligence", h: "#lab" },
      { l: "Daily brief", h: "#summary" },
    ],
  },
  {
    title: "Company",
    links: [
      { l: "About", h: "#pillars" },
      { l: "Contact", h: "mailto:hello@healthirl.in" },
      { l: "Privacy", h: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/[0.06] bg-ink-900">
      <div className="absolute inset-x-0 top-0 divider-glow" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-[1.4fr,1fr,1fr,1fr] gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-zinc-400 max-w-sm">
            Personalized preventive healthcare intelligence — built for daily life, not annual check-ups.
          </p>
          <div className="mt-5 flex items-center gap-2">
            {[
              {
                href: "https://x.com/be_allwell",
                t: "x",
                label: "X (Twitter)",
                svg: <path d="M18.244 2H21.5l-7.51 8.59L23 22h-6.81l-5.34-6.99L4.78 22H1.52l8.03-9.19L1 2h6.92l4.83 6.39L18.244 2Zm-1.19 18h1.84L7.05 4H5.1l11.95 16Z" />,
              },
              {
                href: "https://www.linkedin.com/company/allwell-global/",
                t: "linkedin",
                label: "LinkedIn",
                svg: <><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8" cy="9" r="1.2" fill="currentColor"/><path d="M7 11h2v6H7zM12 17v-3a2 2 0 1 1 4 0v3M12 11h2v6h-2z"/></>,
              },
              {
                href: "https://instagram.com/health_irl",
                t: "instagram",
                label: "Instagram",
                svg: <><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor"/></>,
              },
              {
                href: "mailto:hello@healthirl.in",
                t: "mail",
                label: "Email",
                svg: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 7 9-7"/></>,
              },
            ].map((s) => (
              <a
                key={s.t}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                data-testid={`social-${s.t}`}
                className="h-9 w-9 rounded-md border border-white/10 text-zinc-300 hover:text-emerald-300 hover:border-emerald-400/40 inline-flex items-center justify-center transition-colors"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill={s.t === "x" ? "currentColor" : "none"} stroke={s.t === "x" ? "none" : "currentColor"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{s.svg}</svg>
              </a>
            ))}
          </div>
        </div>

        {sections.map((s) => (
          <div key={s.title}>
            <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">{s.title}</div>
            <ul className="mt-4 space-y-2.5">
              {s.links.map((l) => (
                <li key={l.l}>
                  <a href={l.h} className="text-sm text-zinc-300 hover:text-emerald-300 transition-colors">{l.l}</a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/[0.04] py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-zinc-500">© {new Date().getFullYear()} healthIRL. All rights reserved.</div>
          <div className="text-[11px] font-mono text-zinc-600">v0.1 · Private Beta</div>
        </div>
      </div>
    </footer>
  );
}
